// extracted by mini-css-extract-plugin
export default {"returnToTop":"ReturnToTop_returnToTop__-9U1V"};